import { Button, Skeleton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { FC, useMemo } from 'react'
import {
    useUserNotificationsInfoApiV1NotificationsSettingsGet,
    useUserNotificationsUpdateApiV1NotificationsSettingsPatch,
} from '../../../../api/gen/base'
import TelegramIcon from '../../../../assets/icons/Telegram.svg'
import telegramBotImage from '../../../../assets/images/telegram-bot.png'
import { TELEGRAM_BOT_URL } from '../../../../constants/links.constants'
import { useUserStore } from '../../../../store/storeUser'
import { Block } from './Block'

export const TelegramAccountNotifications: FC = () => {
    const { breakpoints } = useTheme()
    const { userPersonalData, isUserPersonalDataFetched } = useUserStore((state) => state)

    const isMobile = useMediaQuery(breakpoints.down('md'))

    const showLinkAccountButton = !userPersonalData?.social_id

    const { data: settingsData, isLoading: isLoadingSettings } =
        useUserNotificationsInfoApiV1NotificationsSettingsGet(undefined, {
            query: {
                enabled: !showLinkAccountButton,
            },
        })

    const {
        data: updateSettingsData,
        mutate: updateSettings,
        isPending: isUpdatingSettings,
    } = useUserNotificationsUpdateApiV1NotificationsSettingsPatch()

    const isEnabledNotifications = updateSettingsData
        ? !!updateSettingsData.is_enabled
        : !!settingsData?.is_enabled

    const handleToggleNotifications = () => {
        updateSettings({
            data: {
                is_enabled: !isEnabledNotifications,
                notification_channel: 'TELEGRAM',
            },
        })
    }

    const handleClickOpen = () => {
        window.open(TELEGRAM_BOT_URL, '_blank', 'noopener')
    }

    const actionButtons = useMemo(
        () =>
            isLoadingSettings || !isUserPersonalDataFetched ? (
                <Skeleton
                    variant="rounded"
                    sx={{
                        width: '247px',
                        minHeight: '40px',
                        borderRadius: '100px',
                    }}
                />
            ) : (
                <>
                    {showLinkAccountButton ? (
                        <Button
                            variant="contained"
                            onClick={handleClickOpen}
                            sx={{
                                width: '247px',

                                [breakpoints.down('md')]: {
                                    width: '100%',
                                },
                            }}>
                            Перейти в Telegram–bot
                        </Button>
                    ) : (
                        <Stack
                            sx={{
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 1,

                                [breakpoints.down('md')]: {
                                    width: '100%',

                                    flexDirection: 'column',
                                    gap: 3,
                                },
                            }}>
                            <Stack
                                direction="row"
                                gap={1}
                                alignItems="center"
                                sx={{
                                    p: '10px 16px 10px 12px',
                                    border: '1px solid #E7E8EE',
                                    borderRadius: '100px',
                                    ':hover': {
                                        borderRadius: '100px',
                                    },
                                }}>
                                <TelegramIcon />
                                <Typography variant="body2">
                                    Уведомления {isEnabledNotifications ? 'включены' : 'отключены'}
                                </Typography>
                            </Stack>
                            <Button
                                disabled={isUpdatingSettings}
                                variant={!isEnabledNotifications ? 'contained' : 'text'}
                                onClick={handleToggleNotifications}
                                sx={{
                                    backgroundColor: isEnabledNotifications ? '#EFF6FF' : undefined,
                                    width: '124px',

                                    [breakpoints.down('md')]: {
                                        width: '100%',
                                    },
                                }}>
                                {isEnabledNotifications ? 'Отключить' : 'Включить'}
                            </Button>
                        </Stack>
                    )}
                </>
            ),
        [
            isEnabledNotifications,
            isUpdatingSettings,
            showLinkAccountButton,
            isLoadingSettings,
            isUserPersonalDataFetched,
        ],
    )

    return (
        <Block>
            <Stack
                sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',

                    [breakpoints.down('md')]: {
                        flexDirection: 'column',
                        gap: 3,
                    },
                }}>
                <Stack gap={2}>
                    <Typography variant="h4">Telegram–bot ARHIASSISTANT</Typography>
                    <Typography variant="body2" color="#5A5F72">
                        Бот сервиса Arhiassistant – персональный помощник у вас в кармане
                    </Typography>
                    {!isMobile && actionButtons}
                </Stack>
                <img
                    loading="lazy"
                    src={telegramBotImage}
                    style={{ maxWidth: '116px', display: 'flex' }}
                    alt="telegram bot"
                />
                {isMobile && actionButtons}
            </Stack>
        </Block>
    )
}
